import { createSelector } from 'reselect';

const selectLocation = (state) => state.location;

const selectLocationList = createSelector(
	selectLocation,
	(location) => location?.list
);

const getLocationsAddress = createSelector(
	selectLocation,
	(location) => location?.address
);
const getPointToLocations = createSelector(
	selectLocation,
	(location) => location?.pointToLocation
);

const getNeshanPosition = createSelector(
	selectLocation,
	(location) => location?.neshanPosition
);
const getLocationGeneral = createSelector(
	selectLocation,
	(location) => location?.locationGeneral
);
const getLocationProvince = createSelector(
	selectLocation,
	(location) => location?.locationProvince
);

const getLocationCity = createSelector(
	selectLocation,
	(location) => location?.locationCity
);

const getLocationDistrict = createSelector(
	selectLocation,
	(location) => location?.locationDistrict
);

const getLocationArea = createSelector(
	selectLocation,
	(location) => location?.locationArea
);

const locationSelectors = {
	selectLocation,
	selectLocationList,
	getLocationsAddress,
	getPointToLocations,
	getNeshanPosition,
	getLocationGeneral,
	getLocationProvince,
	getLocationCity,
	getLocationDistrict,
	getLocationArea,
};

export default locationSelectors;
